import { PUBLIC_URL } from "./utils/publicPath";

const config = { baseURL: `${PUBLIC_URL}/handleUserInfo/` };

export default config;
